import * as z from "zod";

export const updateTicketNeedsContext = {
  name: "updateTicketNeedsContext" as const,
  input: z.object({ linearTicketId: z.string(), needsContext: z.boolean() }),
  output: z.object({ success: z.boolean(), updatedCount: z.number() }),
};
